<template>
  <div class="details-right">
    <div class="city-card">
      <p class="details-right-name">驾驶室/车厢监控</p>
      <div class="videoContent classDiv">
        <!-- 1 -->
        <video class="videoElement" id="vPull" autoplay controls width="50%" height="100%" />
        <!-- 2 -->
        <!-- <div class="wenDu">
          <div>温度: {{ driverInfoHumidity.tempture || '-' }} 湿度: {{ driverInfoHumidity.humidity || '-' }}</div>
        </div> -->
        <video class="videoElement" id="vPull6" autoplay controls width="50%" height="100%" />
      </div>
      <div class="videoContent">
          <!--  -->
          <video class="videoElement" id="videoElementSlider0" autoplay controls width="50%" height="100%" />
          <video class="videoElement" id="videoElementSlider1" autoplay controls width="50%" height="100%" />

      </div>
      <div class="videoContent">
          <!--  -->
          <video class="videoElement" id="videoElementSlider2" autoplay controls width="50%" height="100%" />
          <video class="videoElement" id="videoElementSlider3" autoplay controls width="50%" height="100%" />
      </div>
    </div>
    <!-- <div class="details-right-center">
      <p class="details-right-name">车外监控</p>
      <div class="videoContent2">
          <slider ref="slider" :options="options" @slide='slide' @tap='onTap' @init='onInit'>
            <slideritem v-for="(item, index) in pages" :key="index" :style="item.style">
              <video class="videoElement" :id="'videoElementSlider' + index" autoplay controls width="100%" height="100%" />
            </slideritem>
            <div slot="loading">loading...</div>
          </slider>
      </div>
    </div> -->
    <!-- <div class="details-right-center">
      <p class="details-right-name">车外监控</p>
      <div class="videoContent2">
          <video class="videoElement" id="videoElementSlider0" autoplay controls width="50%" height="100%" />
          <video class="videoElement" id="videoElementSlider1" autoplay controls width="50%" height="100%" />

      </div>
    </div>
    <div class="details-right-center">
      <p class="details-right-name">车外监控</p>
      <div class="videoContent2">
          <video class="videoElement" id="videoElementSlider2" autoplay controls width="50%" height="100%" />
          <video class="videoElement" id="videoElementSlider3" autoplay controls width="50%" height="100%" />
      </div>
    </div> -->
    <div class="details-right-bottom-1">
      <p class="details-right-name">车辆报警事件</p>
      <div>
        <table border="1"
          style="width: 100%;text-align: center;line-height: 2.3vh;border: 1px solid #053b4b;margin-top: 1vh;">
          <tr style="color: #08e2f2;">
            <th>报警事件</th>
            <th>人员姓名</th>
            <th>报警时间</th>
          </tr>
          <tr v-for="(item, i) in policeInfo" :key="i">
            <td>{{ item.alarmName || '-' }}</td>
            <td>{{ item.driverName || '-' }}</td>
            <td>{{ item.dataTime || '-' }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// import { slider, slideritem } from 'vue-concise-slider'
import common from '@/common/utils'
import api from '../api'
import dayjs from 'dayjs'
import flvJs from 'flv.js'
const start = dayjs(new Date() - 60 * 60 * 24 * 1000).format(
  'YYYY-MM-DD 00:00:00'
)
const end = dayjs(new Date() - 60 * 60 * 24 * 1000).format(
  'YYYY-MM-DD 23:59:59'
)
export default {
  components: {
    // slider,
    // slideritem
  },
  props: {
    vin: {
      type: String,
      default: ''
    },
    static: {
      type: Object,
      default () {
        return {}
      }
    },
    vehicleInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    callPoliceInfo: {
      type: Array,
      default () {
        return []
      }
    },
    chargeRecord: {
      type: Array,
      default () {
        return []
      }
    },
    runKmRecord: {
      type: Array,
      default () {
        return []
      }
    },
    obdRecord: {
      type: Array,
      default () {
        return []
      }
    },
    protocalType: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      pages: [
        {
          html: 'http://61.149.8.85:2103/page/video/013330000502-2',
          style: {
            'background': '#000000'
          }
        },
        {
          html: 'http://61.149.8.85:2103/page/video/013330000502-3',
          style: {
            'background': '#000000'
          }
        },
        {
          html: 'http://61.149.8.85:2103/page/video/013330000502-4',
          style: {
            'background': '#000000'
          }
        },
        {
          html: 'http://61.149.8.85:2103/page/video/013330000502-5',
          style: {
            'background': '#000000'
          }
        }
      ],
      videoUrl: '',
      player: null,
      player6: null,
      player2: null,
      player3: null,
      player4: null,
      player5: null,
      playerNew: null,
      options: {
        direction: 'vertical',
        itemAnimation: true,
        centeredSlides: true,
        loopedSlides: 2,
        slidesToScroll: 1
      },
      videoId: null,
      video: {
        // 视频播放源
        url: '/mp4/MyVideo_2.avi',
        // 视频海报
        // cover: 'https://i.loli.net/2019/06/06/5cf8c5d9c57b510947.png',
        muted: false, // 是否静音播放
        loop: false, // 视频是否循环播放
        preload: 'auto', // 视频预加载
        poster: '', // 原生视频默认海报暂不设置
        volume: 1, // 默认音量
        autoplay: true // 视频自动播放
      },
      start: '00 - 00 - 00',
      entd: '23 - 59 - 59',
      searchData: {
        startTime: start,
        endTime: end
      },
      driverInfoHumidity: {},
      myRunKmRecord: null,
      myChargeRecord: null,
      myObdRecord: []
    }
  },
  computed: {
    policeInfo () {
      const data = this.callPoliceInfo || []
      console.log('右下-车辆报警事件', data)
      return data
    }
  },
  mounted () {
    this.getConfigs()
  },
  watch: {
    vin (val) {
      if (val) this.searchTrack()
    },
    vehicleInfo: {
      handler (newval, oldval) {
        this.driverInfoHumidity = newval
      },
      deep: true
    }
  },
  methods: {
    getConfigs () {
      common.getConfig().then(res => {
        // console.log(res.data.data.BASE_URL)
        this.videoUrl = res.data.data.VIDEO_URL
        this.playVideo()
      })
    },
    slide (data) {
      var that = this
      var videoID = 2
      if (that.playerNew) {
        that.playerNew.pause()
        that.playerNew.destroy()
        that.playerNew = null
      }
      if (data.currentPage === 0) {
        that.videoId = document.getElementById('videoElementSlider0')
        videoID = 2
      } else if (data.currentPage === 1) {
        that.videoId = document.getElementById('videoElementSlider1')
        videoID = 3
      } else if (data.currentPage === 2) {
        that.videoId = document.getElementById('videoElementSlider2')
        videoID = 4
      } else if (data.currentPage === 3) {
        that.videoId = document.getElementById('videoElementSlider3')
        videoID = 5
      } else {
        that.videoId = document.getElementById('videoElementSlider0')
        videoID = 2
      }
      setTimeout(() => {
        if (flvJs.isSupported()) {
          that.playerNew = flvJs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: this.videoUrl + '/page/video/' + that.vehicleInfo.imei + '-' + videoID
              // url: 'http://20.20.7.1:2103/page/video/' + that.vehicleInfo.imei + '-' + videoID
            },
            {
              enableWorker: false, // 不启用分离线程
              enableStashBuffer: false, // 关闭IO隐藏缓冲区
              autoCleanupMinBackwardDuration: true,
              isLive: true,
              lazyLoad: false
            }
          )
        } else {
          console.log('不支持的格式')
          return
        }
        that.playerNew.attachMediaElement(that.videoId)
        that.playerNew.load()
        that.playerNew.play()
      }, 1600)
    },
    destruction () {
      // 销毁对象
      if (this.player) {
        // this.player.pause()
        this.player.destroy()
        this.player = null
        // -
        // this.player6.pause()
        this.player6.destroy()
        this.player6 = null
        // -
        // this.player2.pause()
        this.player2.destroy()
        this.player2 = null
        // -
        // this.player3.pause()
        this.player3.destroy()
        this.player3 = null
        // -
        // this.player4.pause()
        this.player4.destroy()
        this.player4 = null
        // -
        // this.player5.pause()
        this.player5.destroy()
        this.player5 = null
        // this.playerNew.pause()
        this.playerNew.destroy()
        this.playerNew = null
      }
    },
    onTap (data) {
      console.log('onTap', data)
    },
    onInit (data) {
      // console.log('onInit', data)
    },
    playVideo () {
      var that = this
      var vPull = document.getElementById('vPull') // 定义播放路径
      var vPull6 = document.getElementById('vPull6') // 定义播放路径
      // 客户要求6路视频全部展示（暂时）
      var videoElementSlider0 = document.getElementById('videoElementSlider0')
      var videoElementSlider1 = document.getElementById('videoElementSlider1')
      var videoElementSlider2 = document.getElementById('videoElementSlider2')
      var videoElementSlider3 = document.getElementById('videoElementSlider3')
      setTimeout(() => {
        if (flvJs.isSupported()) {
          that.player = flvJs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: this.videoUrl + '/page/video/' + that.vehicleInfo.imei + '-1'
              // url: 'http://20.20.7.1:2103/page/video/' + that.vehicleInfo.imei + '-1'
            },
            {
              enableWorker: false, // 不启用分离线程
              enableStashBuffer: false, // 关闭IO隐藏缓冲区
              isLive: true,
              lazyLoad: false
            }
          )
        } else {
          console.log('不支持的格式')
          return
        }
        that.player.attachMediaElement(vPull)
        that.player.load()
        that.player.play()
      }, 1000)
      setTimeout(() => {
        if (flvJs.isSupported()) {
          that.player6 = flvJs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: this.videoUrl + '/page/video/' + that.vehicleInfo.imei + '-3'
              // url: 'http://20.20.7.1:2103/page/video/' + that.vehicleInfo.imei + '-3'
            },
            {
              enableWorker: false, // 不启用分离线程
              enableStashBuffer: false, // 关闭IO隐藏缓冲区
              isLive: true,
              lazyLoad: false
            }
          )
        } else {
          console.log('不支持的格式')
          return
        }
        that.player6.attachMediaElement(vPull6)
        that.player6.load()
        that.player6.play()
      }, 2000)
      // 客户要求6路视频全部展示（暂时）start
      setTimeout(() => {
        if (flvJs.isSupported()) {
          that.player2 = flvJs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: this.videoUrl + '/page/video/' + that.vehicleInfo.imei + '-2'
              // url: 'http://20.20.7.1:2103/page/video/' + that.vehicleInfo.imei + '-3'
            },
            {
              enableWorker: false, // 不启用分离线程
              enableStashBuffer: false, // 关闭IO隐藏缓冲区
              isLive: true,
              lazyLoad: false
            }
          )
        } else {
          console.log('不支持的格式')
          return
        }
        that.player2.attachMediaElement(videoElementSlider0)
        that.player2.load()
        that.player2.play()
      }, 2000)
      setTimeout(() => {
        if (flvJs.isSupported()) {
          that.player3 = flvJs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: this.videoUrl + '/page/video/' + that.vehicleInfo.imei + '-6'
              // url: 'http://20.20.7.1:2103/page/video/' + that.vehicleInfo.imei + '-3'
            },
            {
              enableWorker: false, // 不启用分离线程
              enableStashBuffer: false, // 关闭IO隐藏缓冲区
              isLive: true,
              lazyLoad: false
            }
          )
        } else {
          console.log('不支持的格式')
          return
        }
        that.player3.attachMediaElement(videoElementSlider1)
        that.player3.load()
        that.player3.play()
      }, 2000)
      setTimeout(() => {
        if (flvJs.isSupported()) {
          that.player4 = flvJs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: this.videoUrl + '/page/video/' + that.vehicleInfo.imei + '-4'
            },
            {
              enableWorker: false, // 不启用分离线程
              enableStashBuffer: false, // 关闭IO隐藏缓冲区
              isLive: true,
              lazyLoad: false
            }
          )
        } else {
          console.log('不支持的格式')
          return
        }
        that.player4.attachMediaElement(videoElementSlider2)
        that.player4.load()
        that.player4.play()
      }, 2000)

      setTimeout(() => {
        if (flvJs.isSupported()) {
          that.player5 = flvJs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: this.videoUrl + '/page/video/' + that.vehicleInfo.imei + '-5'
            },
            {
              enableWorker: false, // 不启用分离线程
              enableStashBuffer: false, // 关闭IO隐藏缓冲区
              isLive: true,
              lazyLoad: false
            }
          )
        } else {
          console.log('不支持的格式')
          return
        }
        that.player5.attachMediaElement(videoElementSlider3)
        that.player5.load()
        that.player5.play()
      }, 2000)
      // 客户要求6路视频全部展示（暂时）end
    },
    searchTrack () {
      const self = this
      const vin = this.vin
      const start = this.searchData.startTime
      const end = this.searchData.endTime
      console.log(this.protocalType === 6)
      if (this.protocalType === 6) {
        api.getObdFaultOrOilStatis({
          vid: vin,
          beginTime: start,
          endTime: end,
          start: 0,
          limit: 9999
        }).then((res) => {
          console.log(res)
          self.myObdRecord = res.data.data.rows
        })
      }
      const getData = async function () {
        // 充电记录
        const chargeRecord = await api.getChargeRecord({
          vid: vin,
          startTime: start,
          endTime: end
        })
        // OBD
        // if (self.protocalType === 5) {
        // 行驶记录
        const runKmRecord = await api.getRunKmRecord({
          vid: vin,
          startTime: start,
          endTime: end
        })
        // }
        self.myChargeRecord = chargeRecord.data.data
        self.myRunKmRecord = runKmRecord.data.data
      }
      getData()
    },
    lastDay () {
      const start = dayjs(new Date() - 60 * 60 * 24 * 1000).format(
        'YYYY-MM-DD 00:00:00'
      )
      const end = dayjs(new Date() - 60 * 60 * 24 * 1000).format(
        'YYYY-MM-DD 23:59:59'
      )
      this.searchData = {
        startTime: start,
        endTime: end
      }
    },
    beforeDay () {
      const start = dayjs(new Date() - 60 * 60 * 24 * 1000 * 2).format(
        'YYYY-MM-DD 00:00:00'
      )
      const end = dayjs(new Date() - 60 * 60 * 24 * 1000 * 2).format(
        'YYYY-MM-DD 23:59:59'
      )
      this.searchData = {
        startTime: start,
        endTime: end
      }
    },
    destroyPlayer () {
      var that = this
      let AllData = [
        { name: '摄像头1', id: 1 },
        { name: '摄像头2', id: 2 },
        { name: '摄像头3', id: 3 },
        { name: '摄像头4', id: 4 },
        { name: '摄像头5', id: 5 },
        { name: '摄像头6', id: 6 }
      ]
      AllData.forEach((item, jj) => {
        let pp = {
          'phone': that.vehicleInfo.imei,
          'channel': item.id
        }
        api.postsendMsg(pp).then(res => {
          // console.log('res', res)
        })
      })
    }
  },
  beforeDestroy () {
    this.destroyPlayer()
    this.destruction()
  }
}
</script>
<style lang="scss" scoped>
.details-right {
  font-size: 0.25rem;
  margin-top: -0.19rem;

  .eacharts-tit {
    font-size: 0.2rem;
    color: #aecbd9;
    text-align: center;
    line-height: 0.9rem;
  }

  .home-tit {
    font-size: 0.26rem;
    color: #07e2f2;
    padding-left: 0.3rem;
    padding-top: 0.09rem;
  }

  .details-right-name {
    color: #07e2f2;
    padding-left: 0.3rem;
    padding-top: 0.09rem;
    font-size: 0.32rem;
  }

  .details-right-top {
    width: 10.65rem;
    height: 4.53rem;
    margin: 0 0 0 0.28rem;
    background: url("../../../assets/images/bg-xiangxi-you1.png") no-repeat;
    background-size: contain;

    .bor-box1 {
      margin-left: 0.28rem;
    }

    div {
      width: 5.32rem;
      height: 4.14rem;
      float: left;
      box-sizing: border-box;
      position: relative;

      p {
        font-size: 0.2rem;
        color: #aecbd9;
        top: 0.3rem;
        left: 2.48rem;
        position: absolute;
      }

      .details-right-box1 {
        height: 3rem;
      }
    }
  }

  .details-right-center {
    // width: 10.65rem;
    // height: 4.49rem;
    width: 28vw;
    height: 18vh;
    margin: 0.34rem 0 0 0.28rem;
    font-size: 2vh;
    line-height: 2;
    background: url("../../../assets/images/bg-xiangxi-you2.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    &>.search-header {
      float: left;
      color: #00c0ff;
      margin-top: 0.34rem;
      margin-left: 0.47rem;
    }

    .search-header {
      span {
        float: left;
      }

      .time {
        width: 2.19rem;
        height: 0.32rem;
        float: left;
        margin-left: 0.13rem;
      }

      .button {
        float: left;
        background: rgba(0, 192, 255, 0.25);
        border: solid 0.007rem #00c0ff;
        color: #00c0ff;
        width: 0.88rem;
        height: 0.32rem;
        font-size: 0.18rem;
        margin-left: 0.42rem;
      }

      .endTime {
        margin-left: 0.42rem;
      }

      a {
        float: left;
        color: #00c0ff;
        border-bottom: solid 0.007rem #00c0ff;
        margin-left: 0.29rem;
        font-size: 0.18rem;
      }
    }

    .search {
      width: 4.75rem;
      float: left;
      margin-top: 0.25rem;

      p {
        color: #aecbd9;
        font-size: 0.2rem;
        margin-left: 0.48rem;
      }

      .search-box {
        position: relative;
        height: 2.6rem;
        overflow: hidden;

        .fengexian {
          width: 0.02rem;
          height: 2.19rem;
          background-color: #979797;
          position: absolute;
          left: 0.79rem;
          top: 0.33rem;
        }

        .search-more-box {
          margin-left: 0.48rem;

          .search-more {
            width: 4.75rem;
            height: 0.25rem;
            float: left;
            position: relative;
            margin-top: 0.26rem;

            .dikuanga {
              width: 0.64rem;
              height: 0.21rem;
              color: #333;
              font-size: 0.13rem;
              border-radius: 0.013rem;
              position: absolute;
              top: 0;
              left: 0;
              background-color: #21d6ac;
              text-align: center;
              line-height: 0.21rem;
            }

            .dikuangb {
              width: 0.64rem;
              height: 0.21rem;
              color: #333;
              font-size: 0.13rem;
              border-radius: 0.013rem;
              position: absolute;
              top: 0;
              left: 0;
              background-color: #01b7f3;
              text-align: center;
              line-height: 0.21rem;
            }

            .dikuangc {
              width: 0.64rem;
              height: 0.21rem;
              color: #333;
              font-size: 0.13rem;
              border-radius: 0.013rem;
              position: absolute;
              top: 0;
              left: 0;
              background-color: #233951;
              text-align: center;
              line-height: 0.21rem;
            }

            .sanjiaoa {
              width: 0;
              height: 0;
              border-width: 0.03rem;
              border-style: solid;
              border-color: transparent #21d6ac transparent transparent;
              transform: rotate(180deg);
              position: absolute;
              top: 0.06rem;
              left: 0.64rem;
            }

            .sanjiaob {
              width: 0;
              height: 0;
              border-width: 0.03rem;
              border-style: solid;
              border-color: transparent #01b7f3 transparent transparent;
              transform: rotate(180deg);
              position: absolute;
              top: 0.06rem;
              left: 0.64rem;
            }

            .sanjiaoc {
              width: 0;
              height: 0;
              border-width: 0.03rem;
              border-style: solid;
              border-color: transparent #233951 transparent transparent;
              transform: rotate(180deg);
              position: absolute;
              top: 0.06rem;
              left: 0.64rem;
            }

            .yuan {
              width: 0.03rem;
              height: 0.03rem;
              border-radius: 0.015rem;
              background-color: #fbce01;
              position: absolute;
              top: 0.06rem;
              left: 0.78rem;
            }

            .content {
              font-size: 0.18rem;
              color: #ffffff;
              position: absolute;
              width: 3.79rem;
              top: 0rem;
              left: 0.98rem;
              text-align: left;
              margin: 0rem;
            }
          }
        }
      }
    }
  }

  .details-right-bottom {
    width: 10.65rem;
    height: 4.09rem;
    margin: 0.34rem 0 0 0.28rem;
    background: url("../../../assets/images/bg-xiangxi-you3.png") no-repeat;
    background-size: contain;
    position: relative;

    .calender-box {
      height: 3.54rem;
    }

    .calendar {
      float: left;
      width: 2.92rem;
      height: 3.38rem;
      margin-top: 0.3rem;
      margin-left: 0.5rem;
    }

    .calendar-box .calendar:first-child {
      margin-left: 0.35rem;
    }
  }

  .details-right-bottom::-webkit-scrollbar {
    height: 0.05rem;
  }

  .details-right-bottom::-webkit-scrollbar-thumb {
    border-radius: 0.01rem;
    background: #22e1b4;
  }

  .details-right-bottom::-webkit-scrollbar-track {
    border-radius: 0.05rem;
    background: #00c0ff;
  }

  .city-card {
    // width: 10.65rem;
    // height: 4.54rem;
    width: 28vw;
    height: 55vh;
    background: url("../../../assets/images/bg-xiangxi-you1.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    margin-left: 0.28rem;

    .city-card-eacharts {
      display: flex;
    }

    .city-card-travel,
    .city-card-power {
      width: 100%;

      &>div {
        height: 3rem;
      }
    }
  }
}
</style>
<style lang="scss">
.block .el-input--prefix .el-input__inner {
  padding-left: 0.13rem;
}

.wenDu {
  position: absolute;
  right: 5%;
  z-index: 9999;
  background: #081623;
  padding: 2px 7px;
}

.classDiv {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-end;
  justify-content: center;
}

.block {
  float: left;
  width: 2.32rem;
  height: 0.32rem;

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 2.45rem;
    height: 0.32rem;
    font-size: 0.18rem;
  }

  .el-input--prefix .el-input__inner {
    height: 0.32rem;
    background: rgba(0, 192, 255, 0.08);
    border: 0.01rem solid rgba(0, 192, 255, 0.7);
    border-radius: 0;
    color: #fff;
    font-size: 0.18rem;
  }

  .el-input--prefix .el-input__inner {
    padding: 0;
  }

  .el-input__prefix {
    display: none;
  }

  .el-input__suffix {
    display: none;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 0;
    padding-left: 0.13rem;
  }
}

.obd {
  display: flex;
  line-height: 0.25rem;

  .obd-left {
    color: #21D6AC;
    padding-left: 0.15rem;
    padding-right: 0.15rem;
  }

  .obd-right {
    color: #FFF;
  }
}

.details-left-bottom-left1 {
  float: left;

  p {
    width: 1.18rem;
    height: 0.47rem;
    line-height: 0.47rem;
    background: url("../../../assets/images/bg-xiangxi-zuo3-zhengche.png") no-repeat;
    background-size: contain;
    text-align: center;
    margin-left: 0.53rem;
    margin-top: 0.36rem;
    color: #07e2f2;
    font-size: 0.35rem;
  }

  .zhengche span:nth-child(odd) {
    float: left;
    color: #07e2f2;
    width: 1.56rem;
    margin-top: 0.3rem;
    margin-left: 0.53rem;
    font-size: 1.6vh;
    line-height: 2;
  }

  .zhengche span:nth-child(even) {
    float: left;
    color: #fff;
    width: 1rem;
    margin-top: 0.3rem;
    margin-left: 0.16rem;
  }
}

.details-left-bottom-center {
  float: left;

  p {
    width: 1.47rem;
    height: 0.47rem;
    line-height: 0.47rem;
    background: url("../../../assets/images/bg-xiangxi-zuo3-donglixitong.png") no-repeat;
    background-size: contain;
    text-align: center;
    margin-left: 0.5rem;
    margin-top: 0.36rem;
    color: #07e2f2;
  }

  .xitong span:nth-child(odd) {
    float: left;
    color: #07e2f2;
    width: 14vh;
    margin-top: 0.3rem;
    margin-left: 0.53rem;
  }

  .xitong span:nth-child(even) {
    float: left;
    color: #fff;
    width: 1rem;
    margin-top: 0.3rem;
    margin-left: 0.26rem;
  }
}

.details-left-bottom-right {
  float: left;

  span {
    height: 0.33rem;
  }

  p {
    width: 1.18rem;
    height: 0.47rem;
    line-height: 0.47rem;
    background: url("../../../assets/images/bg-xiangxi-zuo3-zhengche.png") no-repeat;
    background-size: contain;
    text-align: center;
    margin-left: 0.5rem;
    margin-top: 0.36rem;
    color: #07e2f2;
  }

  .weizhi span:nth-child(odd) {
    float: left;
    color: #07e2f2;
    width: 1.6rem;
    margin-top: 0.3rem;
    margin-left: 0.5rem;
  }

  .weizhi span:nth-child(even) {
    float: left;
    color: #fff;
    width: 1.43rem;
    margin-top: 0.3rem;
    margin-left: 0.28rem;
  }
}

.details-right-bottom-1 {
  width: 28vw;
  height: 35vh;
  margin: 0.34rem 0 0 0.28rem;
  background: url("../../../assets/images/bg-xiangxi-zuo001.png") no-repeat;
  background-size: 100% 100%;
  position: relative;

  .details-left-name {
    color: #07e2f2;
    padding-left: 0.3rem;
    padding-top: 0.09rem;
    font-size: 0.26rem;
  }

  .details-left-more {
    float: left;
  }

  .details-left-more span:nth-of-type(odd) {
    float: left;
    margin-left: 0.2rem;
    color: #07e2f2;
    width: 2rem;
    // height: 0.46rem;
    // margin-top: 0.22rem;
    margin-top: 0.11rem;
    margin-bottom: 0.45rem;
    font-size: 1.85vh;
    line-height: 2;
  }

  .details-left-more span:nth-of-type(even) {
    float: left;
    margin-left: 0.2rem;
    color: #fff;
    width: 2rem;
    // margin-top: 0.22rem;
    margin-top: 0.11rem;
    margin-bottom: 0.45rem;
    // height: 0.46rem;
    font-size: 1.6vh;
    line-height: 2;
  }

  .details-left-more-box li:nth-of-type(even) span:first-child {
    width: 2.45rem;
  }

  .details-left-more-box li:nth-of-type(even) span:last-child {
    width: 2.48rem;
  }

  .details-left-more-box li:nth-child(-n + 2) span {
    margin-top: 0.57rem;
  }
}

// 让视频自动适应高度
.videoContent {
  // width: 10.4rem;
  // height:3.80rem;
  width: 27.2vw;
  height: 16.5vh;
  padding: 0.1rem;
  // display: flex;
  // justify-content:center;
  // align-items:center;
}

.videoContent2 {
  // width: 10.4rem;
  // height:3.80rem;
  width: 27.2vw;
  // height: 24vh;
  height: 16.5vh;
  padding: 0.1rem;
  // display: flex;
  // justify-content:center;
  // align-items:center;
}

.videoElement {
  object-fit: fill;
}

.slider-item {
  transform: scale(0.8);
  transition-timing-function: ease;
  transition-duration: 300ms;
}

.slider-item.slider-active {
  transform: scale(1.0);
  z-index: 999;
}

.slider-item.slider-active-copy {
  transform: scale(1.0);
  z-index: 999;
}</style>
